module.exports = __webpack_public_path__ + "img/collection-engagementRingsModern.89139d3.jpg";